module.exports = __webpack_public_path__ + "img/mind_element_audio.006ea4fd.png";